import { Col, Row, Spin } from 'antd'
import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import {
  GreyText,
  Marks,
  SecondaryHeading,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { COLORS } from 'theme'
import GraduationIcon from '../../../../../../../../../components/icons/GratuationIcon'

const EducationSection = ({ studentData, resume }) => {
  const [educationList, setEducationList] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(true)
    let currentCourse = {
      id: studentData?.currentCourse?.id,
      isCurrentCourse: true,
      educationLevel: studentData?.currentCourse?.educationLevel,
      institutionName: studentData?.instituteCampusName,
      board: '',
      degree: studentData?.currentCourse?.degree,
      department: studentData?.currentCourse?.department,
      specialisation: studentData?.currentCourse?.specialisation,
      degreeStreamMapId: studentData?.currentCourse?.degreeStreamMapId,
      startedOn: studentData?.currentCourse?.startedOn,
      endedOn: studentData?.currentCourse?.endedOn,
      marks: studentData?.currentCourse?.marks,
      averageMarks: studentData?.currentCourse?.averageMarks,
      skills: studentData?.currentCourse?.skills,
      state: studentData?.currentCourse?.state || '',
      city: studentData?.currentCourse?.city || '',
      country: studentData?.currentCourse?.country || '',
    }
    let schoolLevel = []
    let collegeLevel = []
    studentData?.educationProfile?.map((item, index) => {
      if (
        item?.educationLevel === 'twelfth' ||
        item?.educationLevel === 'tenth'
      ) {
        schoolLevel.push(item)
      } else {
        collegeLevel.push(item)
      }
    })
    if (studentData?.student?.isExpCandidate) {
      setLoading(true)
      let educationList = [...collegeLevel, ...schoolLevel]

      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)
      setLoading(false)
    } else if (!studentData?.student?.isExpCandidate) {
      setLoading(true)

      let educationList =
        studentData?.educationProfile?.length > 0
          ? [currentCourse, ...collegeLevel, ...schoolLevel]
          : [currentCourse]

      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)

      setLoading(false)
    }
  }, [studentData])
  const getEducationLevelLabel = level => {
    switch (level) {
      case 'tenth':
        return '10th'
      case 'twelfth':
        return '12th'
      case 'puc':
        return 'Diploma'
      case 'p_g_diploma':
        return 'PG Diploma'
      case 'diploma':
        return 'Diploma'
      case 'ug':
        return 'UG'
      case 'pg':
        return 'PG'
      case 'phd':
        return 'PD'
      default:
        break
    }
  }

  const getEducationDate = value => {
    if (
      value.educationLevel === 'ug' ||
      value.educationLevel === 'pg' ||
      value.educationLevel === 'phd' ||
      value.educationLevel === 'diploma' ||
      value.educationLevel === 'p_g_diploma'
    ) {
      return (
        <span>
          {value?.startedOn > 0 ? (
            <>{moment(parseInt(value?.startedOn)).format('YYYY')} - </>
          ) : null}
          {moment(parseInt(value?.endedOn)).format('YYYY')}{' '}
        </span>
      )
    } else if (value?.endedOn > 0) {
      return <span>{moment(parseInt(value?.endedOn)).format('YYYY')} </span>
    }
  }


  const currentDate = moment()

  const getEduLevel = value => {
    if (
      value.educationLevel === 'ug' ||
      value.educationLevel === 'pg' ||
      value.educationLevel === 'phd' ||
      value.educationLevel === 'diploma' ||
      value.educationLevel === 'p_g_diploma'
    ) {
      return value.degree?.toLowerCase() + ' in ' + value.department
    } else {
      return value.board
    }
  }
  const roundOff = mark => {
    return Number(mark).toFixed(2)
  }

  return (
    <>
      {!loading && (
        <SubFLex column gap="25px" style={{ width: '100%' }}>
          {!loading &&
            educationList?.length > 0 &&
            educationList?.map((item, index) => (
              <Row style={{ width: '90%', flexWrap: 'wrap' }}>
                <Col span={20}>
                  <SubFLex gap="12px">
                    <div>
                      <Avatar
                        background="none"
                        size={48}
                        icon={resume ? <GraduationIcon /> : <ApartmentIcon />}
                        boxShadow={true}
                        padding="5px"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <SubFLex gap="20px" flexStart>
                        <SecondaryHeading fontWeight="600">
                        {getEducationLevelLabel(item?.educationLevel)}
                          {getEducationLevelLabel(item?.educationLevel) &&
                            item?.institutionName &&
                            ' - '}
                          {item?.institutionName}
                        </SecondaryHeading>

                        {moment(parseInt(item?.endedOn)).format('YYYY-MM-DD') >
                          currentDate.format('YYYY-MM-DD') ===
                        true ? (
                          <CustomTag
                            message="Currently Pursuing"
                            bordered={true}
                            background="none"
                            colorType="grey"
                            border={COLORS.GREY_T_80}
                          />
                        ) : (
                          <></>
                        )}
                      </SubFLex>
                      <GreyText color={COLORS.GREY_T_60}>
                        {getEducationDate(item)} {item?.city}
                        {item?.city && ','}
                        {item?.state}
                      </GreyText>
                      <GreyText>
                        {getEduLevel(item)}{' '}
                        {item?.specialisation
                          ? `(${item?.specialisation})`
                          : null}
                      </GreyText>
                      {resume ? null : (
                        <>
                          {item?.skills?.length > 0 && (
                            <SecondaryHeading fontWeight="600">
                              Skills
                            </SecondaryHeading>
                          )}
                          <SubFLex
                            centerVertically
                            gap="5px"
                            marginBottom="15px"
                            wrap
                          >
                            {item?.skills?.map((value, key) => (
                              <CustomTag
                                message={value.name}
                                bordered={true}
                                background={'#F2F3F5'}
                                border={'#F2F3F5'}
                              />
                            ))}
                          </SubFLex>
                        </>
                      )}

                      {item?.awards?.length > 0 &&
                        studentData?.student?.isExpCandidate && (
                          <>
                            <br></br>
                            <RewardTite>Rewards and Recognition </RewardTite>
                          </>
                        )}
                      {item?.awards?.map((value, key) => (
                        <SubFLex column gap="25px" marginBottom="10px">
                          <SubFLex gap="12px">
                            <div>
                              <Avatar
                                background="none"
                                size={48}
                                icon={<AwardsIconWork />}
                                boxShadow={true}
                                padding="5px"
                              />
                            </div>
                            <SubFLex column style={{ width: '90%' }}>
                              <SecondaryHeading>
                                {value?.title}
                              </SecondaryHeading>

                              <GreyText color={COLORS.GREY_T_60}>
                                {moment(value?.awarded_on).format(
                                  'DD MMM YYYY'
                                )}
                              </GreyText>

                              <StyledP>
                                {' '}
                                <EditorContent
                                  dangerouslySetInnerHTML={{
                                    __html: value?.description || '',
                                  }}
                                />{' '}
                              </StyledP>
                            </SubFLex>
                          </SubFLex>
                        </SubFLex>
                      ))}
                    </SubFLex>
                  </SubFLex>
                </Col>
                <Col span={4}>
                  <div style={{ width: 'max-content' }}>
                    <Marks>
                      {!item?.isCurrentCourse &&
                        'Marks - ' + roundOff(item?.marks) + '%'}

                      {item?.isCurrentCourse && Number(item?.averageMarks) >= 1
                        ? 'Marks  - ' + `${roundOff(item?.averageMarks)}` + '% '
                        : null} 
                    </Marks>
                  </div>
                </Col>
              </Row>
            ))}
        </SubFLex>
      )}
      {loading && <Spin />}
    </>
  )
}

export default EducationSection
